import { useEffect, useState } from "react";
import { fetchReportingWbsData, downloadReportingWbsExcel } from "../Api/ViewReportingWbsReport";
import { Container, Table, Button } from "react-bootstrap";

import { toast } from "react-toastify";
import moment from "moment";

const ViewReportingWbsReport = () => {
  const [reportingWbsData, setReportingWbsData] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    const loadReportingWbsData = async () => {
      try {
        const data = await fetchReportingWbsData();
        setReportingWbsData(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Reporting WBS Data`);
      }
    };

    loadReportingWbsData();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadReportingWbsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'ReportingWBS_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Reporting WBS data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="list-container">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <span className="list-title">View Reporting WBS Report</span>
              <Button className="generate-btn"
                variant="primary" 
                onClick={handleDownload}
                disabled={isDownloading || reportingWbsData.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>

            {reportingWbsData.length > 0 ? (
              <div className="table-wrapper">
                <div className="table-scroll-container">
                  <Table bordered hover className="data-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Reporting WBS</th>
                        <th>Operational Report Head</th>
                        <th>Org Performance</th>
                        <th>Created At</th>
                        <th>Created By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportingWbsData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.reportingWbs}</td>
                          <td>{item.operationalReportHead}</td>
                          <td>{item.orgPerformance}</td>
                          <td>{moment(item.createdAt).format('L')} at {moment(item.createdAt).format('LTS')}</td>
                          <td>{item.createdBy}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p className="no-data">No reporting WBS data found.</p>
            )}
          </Container>
        </div>
      
    </>
  );
};

export default ViewReportingWbsReport;